import AmexSecurityCenter, { ComponentAmexSecurityCenterUnderTest } from './AmexSecurityCenter';

export default AmexSecurityCenter;

export { ComponentAmexSecurityCenterUnderTest };
